import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const loginEmbedRoute: InvariantJiraRoute = {
	name: 'login-embed',
	path: '/jira-login/embed',
};
